import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Image,
  Spin,
  Tooltip,
  Input,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { Label } from '../../../compnents/widgets/Label'
import styles from './personalSetting.module.css'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import {
  CheckOptions,
  Checks,
  clinicCheckOptions,
  clinicChecks,
  getCheckName,
  getClinicCheckName,
  getShopName,
  getTemPlateName,
  Settinglable,
  shopOptions,
} from '../../../models/personalSetting'
import { useQuery } from '../../../utils/HttpUtils'
import { NavBar } from '../../../compnents/nav/NavBar'
import {
  getUserProfileList,
  saveSetting,
} from '../personalDetail/personalDetailSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
  selectEdition,
  selectStationCategory,
  selectTenantCategory,
  selectUserId,
  selectUserName,
} from '../../../app/applicationSlice'
import {
  CaretDownFilled,
  CloseCircleOutlined,
  CloseOutlined,
  QuestionCircleTwoTone,
} from '@ant-design/icons'
import {
  EditableRecipeCategories,
  getRecipeCategoryName,
} from '../../../models/recipe'
import { PreferencesSetModal } from '../../treatment/diagnosis/preferencesSetModal'
import { StationCategory } from '../../../models/user'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getPrintTemplateSettingList } from '../../print/printSlice'

export const PersonalSetting = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const query = useQuery()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const id = query.get('state') as string

  const { Option } = Select

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const tenantCategory = useSelector(selectTenantCategory)

  const [EWFYFlag, setEWFYFlag] = useState<any>(0)

  const [checkData, setCheckData] = useState<any>([])

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [formData, setFormData] = useState<any>([])

  const [ewfyInput, setEwfyInput] = useState('')

  const [data, setData] = useState<string[]>([''])

  const [state, setState] = useState(true)

  const [submitLoading, setSubmitLoading] = useState(false)

  const [preferencesSetShow, setiPreferencesSetShow] = useState(false) //偏好设置

  const [selectedDiseases, setSelectedDiseases] = useState<any[]>([])

  const [printFlag, setPrintFlag] = useState<any>(false)

  const [templateList, setTemplateList] = useState<any>()

  useEffect(() => {
    setTimeout(function () {
      setIsModalVisible(false)
    }, 3000)
  }, [dispatch, isModalVisible])

  useEffect(() => {
    // if (hisVersion == 0) {
    setData(
      checkData.map((v: any) => {
        return v?.code == 5
          ? v.codeName
          : v.codeName === '0'
            ? ''
            : v.codeName === 'true'
              ? '1'
              : v.codeName
      })
    )
    // }
  }, [checkData])

  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  }

  const getShowData = () => {
    dispatch(getUserProfileList({ userId: id || userId }))
      .then(unwrapResult)
      .then((c: any) => {
        setCheckData(c)
        c.map((v: any) => {
          if (v.code === '9') {
            setSelectedDiseases(v.codeMap)
            setEWFYFlag(Number(v.switchFlag))
            // form.setFieldsValue({
            //   [Checks.Ewfy]: [Number(v.switchFlag)],
            // })
          }
        })
      })
  }

  useEffect(() => {
    if (id) {
      dispatch(getUserProfileList({ userId: id }))
        .then(unwrapResult)
        .then((c: any) => {
          setCheckData(c)
          c.map((v: any) => {
            if (v.code === '9') {
              setSelectedDiseases(v.codeMap)
              // form.setFieldsValue({
              //   [Checks.Ewfy]: [Number(v.switchFlag)],
              // })
              setEWFYFlag(Number(v.switchFlag))
            }
          })
        })
    } else {
      dispatch(getUserProfileList({ userId: userId }))
        .then(unwrapResult)
        .then((c: any) => {
          setCheckData(c)
          c.map((v: any) => {
            if (v.code === '9') {
              setSelectedDiseases(v.codeMap)
              // form.setFieldsValue({
              //   [Checks.Ewfy]: [Number(v.switchFlag)],
              // })
              setEWFYFlag(Number(v.switchFlag))
            }
          })
        })
    }
  }, [dispatch])

  useEffect(() => {
    const ZdblszValue = checkData?.filter((v: any) => v?.code == '1')?.[0]
      ?.codeName

    const MrcfszValue = checkData?.filter((v: any) => v?.code == '2')?.[0]
      ?.codeName

    const MRBLValue = checkData?.filter((v: any) => v?.code == '6')?.[0]
      ?.codeName

    const BLFXValue = checkData?.filter((v: any) => v?.code == '4')?.[0]
      ?.codeName

    const SRFSZValue = checkData?.filter((v: any) => v?.code == '5')?.[0]
      ?.codeName

    const XCXQXValue = checkData?.filter((v: any) => v?.code == '7')?.[0]
      ?.codeName

    const MRtsValue = checkData?.filter((v: any) => v?.code == '8')?.[0]
      ?.codeName

    const HbfzValue = checkData?.filter((v: any) => v?.code == '11')?.[0]
      ?.codeName

    const FPXZValue = checkData?.filter((v: any) => v?.code == '12')?.[0]
      ?.codeName

    const TLXCFHBBHBValue = checkData?.filter((v: any) => v?.code == '13')?.[0]
      ?.codeName
    
    const JSHZDTDYYLValue = checkData?.filter((v: any) => v?.code == '14')?.[0]
      ?.codeName
    
    const templateListIds = templateList?.map((v: any) => v?.templateId)

    const FPXZValueId = FPXZValue ? FPXZValue?.split(',') : []

    const existingNumbers = FPXZValueId?.length
      ? FPXZValueId?.filter((num: any) =>
        templateListIds?.includes(num)
      )?.join(',')
      : FPXZValue

    form.setFieldsValue({
      [Checks.Zdblsz]: ZdblszValue ? ZdblszValue?.split(',').map(Number) : [],
      [Checks.Mrcfsz]: MrcfszValue ? MrcfszValue?.split(',').map(Number) : [],
      [Checks.MRBL]: localStorage.getItem('tabNum')
        ? Number(localStorage.getItem('tabNum'))
        : Number(MRBLValue),
      // [Checks.Sc]: data[2] ? data[2]?.split(",").map(Number) : [],
      [Checks.BLFX]: BLFXValue == '1' ? 'true' : 'false',
      [Checks.SRFSZ]: SRFSZValue ? SRFSZValue : '0',
      [Checks.XCXQX]: XCXQXValue == 'true' ? true : false,
      [Checks.Hbfz]: HbfzValue == 'true' ? true : false,
      // [Checks.CFFX]: data[6] === "1" ? "true" : "false",
      [Checks.MRts]: MRtsValue && MRtsValue != 'false' ? MRtsValue : 7,
      [Checks.FPXZ]: existingNumbers ? existingNumbers?.split(',').map(String) : [],
      [Checks.TLXCFHBBHB]: TLXCFHBBHBValue == 'true' ? true :TLXCFHBBHBValue == 'false' ?  false : true,
      [Checks.JSHZDTDYYL]: JSHZDTDYYLValue == 'true' ? true : (JSHZDTDYYLValue ? false : true) ,
    })

    setPrintFlag(FPXZValue ? true : false)
  }, [dispatch, checkData])

  useEffect(() => {
    if (data?.length) {
      setFormData(
        data[0]
          ? data[0]
            ?.split(',')
            ?.filter((v) => v != '5' && v != '6')
            ?.map(Number)
          : []
      )
    }
  }, [data])

  useEffect(() => {
    //选择要开通的病历 联动
    !formData?.some((item: any) => item == form.getFieldValue([Checks.MRBL])) &&
      form.setFieldsValue({
        [Checks.MRBL]: formData?.[0],
        [Checks.Mrcfsz]:
          formData?.[0] == 2
            ? [3]
            : formData?.[0] == 3
              ? [13]
              : [formData?.[0]],
      })
  }, [formData])

  useEffect(() => {
    dispatch(getPrintTemplateSettingList({ current: 1, size: 500 }))
      .then(unwrapResult)
      .then((v: any) => {
        const data = v?.map((i: any) => {
          return { ...i, templateId: i?.templateId?.toString() }
        })
        setTemplateList(data?.filter((v: any) => v?.state == 1))
      })
  }, [])
  // const getWXBindingFn = () => { //微诊所是否绑定
  //   dispatch(getWXBinding())
  //     .then(unwrapResult)
  //     .then((c: any) => setWXBinding(c))
  // }
  //
  // const getRemoveWXBinding = () => {//微诊所解绑
  //   dispatch(removeBinding())
  //     .then(unwrapResult)
  //     .then((c: any) => getWXBindingFn())
  //
  // }

  return (
    <>
      {id ? (
        <Col
          style={{
            margin: '10px 20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <NavBar
            where={['员工管理', '设置']}
            backtrace={{
              name: '机构管理',
              path: '/tenant/manager',
              state: {
                station: '0',
              },
            }}
          />
        </Col>
      ) : (
        <></>
      )}
      <div className={id ? styles.mains : styles.main}>
        <Label label='功能设置' style={{ marginBottom: 10 }} />
        <Form
          style={{ height: '100%' }}
          {...layout}
          form={form}
          onFinish={(values) => {
            if (values[2].length == 0) {
              notification.error({ message: '请选择默认处方设置' })
              return
            }
            if (!formData?.length) {
              notification.info({
                message: '请至少选择一个病历',
              })
              return
            }
            if (values[Checks.FPXZ]?.length > 10) {
              notification.info({
                message: '最多只能添加10个模板',
              })
              return
            }
            if (hisVersion == 0) {
              values[Checks.Zdblsz] = values.temp
                ? Array.from(
                  new Set([...values.temp, ...values[Checks.Zdblsz]])
                )
                : [...values[Checks.Zdblsz]]
            }
            const ewfy =
              (EWFYFlag == 1 ? '1#' : '0#') +
              selectedDiseases.map((v) => v.id).join(',')
            const pattern = /^[1-9]*$/
            let f =
              values &&
              _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                  ({
                    code: k,
                    codeName:
                      k === Checks.Sc.toString()
                        ? state
                        : k === Checks.XCXQX.toString() || k === Checks.Hbfz.toString()  || k === Checks.TLXCFHBBHB.toString() || k === Checks.JSHZDTDYYL.toString()
                            ? v?.toString()
                              ? true
                              : false
                            : typeof v === 'number' || typeof v === 'string'
                              ? v?.toString()
                              : k === Checks.MRts.toString()
                                ? v?.toString()
                                : k === Checks.Ewfy.toString()
                                  ? ewfy
                                  : k === Checks.FPXZ.toString()
                                    ? printFlag
                                      ? v?.join(',')
                                      : ''
                                    : v?.join(','),
                    userId: id ? id : userId,
                  } as Settinglable)
                )
                .values()
                .value()
            if (hisVersion == 1) {
              // 将新数据放在前面，旧数据放在后面
              f = f.concat(
                checkData
                  .map((v: any) => ({
                    code: v.code,
                    codeName: v.codeName,
                    userId: userId,
                  }))
                  ?.filter((t: any) => t.code != '9')
              )
            }
            const uniqueF = _.uniqBy(f, 'code')

            dispatch(saveSetting(uniqueF))
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功',
                  duration: 3,
                })
                getShowData()
                localStorage.setItem(
                  'tabNum',
                  form.getFieldValue([Checks.MRBL])
                )
                localStorage.setItem(
                  'tipsCount',
                  form.getFieldValue([Checks.MRts])
                    ? form.getFieldValue([Checks.MRts])
                    : 7
                )
              })
              .finally(() => {
                setEwfyInput('')
                setSelectedDiseases([])
                form.setFieldsValue({ [Checks.Ewfy]: [0] })
              })
          }}
        >
          <div style={{height:'calc(100% - 120px)',overflowY:'auto'}}>
            <Row>
              <Form.Item
                label='诊断病历设置'
                name={Checks.Zdblsz}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Checkbox.Group
                  onChange={(e) => {
                    setFormData(e?.filter((v) => v != '5' && v != '6'))
                  }}
                >
                  {CheckOptions.map((c) => {
                    const name = getCheckName(c, tenantCategory)
                    return (
                      <Checkbox
                        key={c}
                        value={c}
                        onChange={(e) => {
                          if (e.target.value == 3 && e.target.checked) {
                            //口腔病历与处置项目联动
                            if (
                              !form.getFieldValue(Checks.Mrcfsz)?.includes(13)
                            ) {
                              form.setFieldsValue({
                                [Checks.Mrcfsz]: [
                                  ...form.getFieldValue(Checks.Mrcfsz),
                                  13,
                                ],
                              })
                            }
                          } else if (e.target.value == 3 && !e.target.checked) {
                            form.setFieldsValue({
                              [Checks.Mrcfsz]: form
                                .getFieldValue(Checks.Mrcfsz)
                                .filter((item: any) => item != 13),
                            })
                          }
                        }}
                      >
                        {name}
                      </Checkbox>
                    )
                  })}
                </Checkbox.Group>
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                label='选择一个默认病历'
                name={Checks.MRBL}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Radio.Group
                  onChange={(e) => {
                    const values =
                      e.target.value == 2
                        ? [3]
                        : e.target.value == 3
                          ? [13]
                          : [e.target.value]
                    form.setFieldsValue({
                      [Checks.Mrcfsz]: values,
                    })
                  }}
                >
                  {formData?.map((c: any) => {
                    return (
                      <Radio key={c} value={c}>
                        {getTemPlateName(c, tenantCategory)}
                      </Radio>
                    )
                  })}
                </Radio.Group>
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                label='保存病历后，自动创建空处方'
                name={Checks.Mrcfsz}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Select
                  style={{ width: '70%' }}
                  className={styles.addtion}
                  mode='multiple'
                  showArrow
                  showSearch={false}
                  // suffixIcon={<CaretDownFilled />}
                  defaultValue={checkData}
                >
                  {EditableRecipeCategories.map((v: any) => (
                    <Option key={v} value={v}>
                      {getRecipeCategoryName(v)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Row>
            <Row className={styles.noMarginBottom}>
              <Form.Item
                label='开方自动生成额外费用'
                name={Checks.Ewfy}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Checkbox
                  checked={EWFYFlag == 1 ? true : false}
                  onClick={(v: any) => {
                    setEWFYFlag(v?.target?.checked ? 1 : 0)
                  }}
                >
                  开启
                  <Tooltip
                    placement='right'
                    title='开启后，在医生开方时会自动生成一个额外费用单，额外费用单里会自动添加设置好的诊疗费用'
                    trigger={['click']}
                  >
                    <QuestionCircleTwoTone style={{ marginLeft: '10px' }} />
                  </Tooltip>
                </Checkbox>
                <Form.Item noStyle>
                  <RecipeItemInput
                    // selectTag={selectTag}
                    isRestrictUser={1} //是否限制用户
                    // wbTag={wbTag}
                    // potionType={potionType}
                    // insuranceCode={insuranceCode}
                    style={{
                      width: '300px',
                      height: '2rem',
                      color: theme.tc1,
                      marginLeft: '50px',
                    }}
                    placeholder='请输入诊疗项目'
                    autoFocus
                    type={2}
                    value={ewfyInput}
                    // category={category}
                    onSelect={(m: any, ignoreStorage: any) => {
                      setEwfyInput('')
                      setSelectedDiseases(
                        selectedDiseases.concat([
                          {
                            id: m.id,
                            name: m.name,
                            price: m.retailPrice,
                          },
                        ])
                      )
                    }}
                    onChange={(v: any) => {
                      setEwfyInput(v)
                    }}
                  />
                  <Col
                    span={24}
                    style={{
                      padding: '10px 10px 0 0px',
                    }}
                  >
                    {selectedDiseases.map((d, index) => (
                      <div key={index} className={styles.disease}>
                        {`${d.name}${d.price}`}
                        {'元 '}
                        <CloseOutlined
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            const list = [...selectedDiseases]
                            list.splice(index, 1)
                            setSelectedDiseases(list)
                          }}
                        />
                      </div>
                    ))}
                  </Col>
                </Form.Item>
              </Form.Item>
            </Row>
            {hisVersion == 0 ? (
              <>
                <Row>
                  <Col span={9}>
                    <Form.Item
                      label='中药默认帖数'
                      name={Checks.MRts}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                      labelCol={{
                        span: 16,
                      }}
                      wrapperCol={{
                        span: 7,
                      }}
                      rules={[
                        {
                          pattern: /[1-9]\d*$/,
                          message: '请输入大于0的整数',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col>
                    <span style={{ position: 'absolute', top: 6, left: '24%' }}>
                      帖
                    </span>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            {/* <Row>
            <Form.Item
              label='商城'
              name={Checks.Sc}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Checkbox.Group>
                {shopOptions.map((c) => {
                  const name = getShopName(c)
                  return (
                    <Checkbox
                      key={c}
                      value={c}
                      onChange={(e) => {
                        setState(e.target.checked)
                      }}
                    >
                      {name}
                    </Checkbox>
                  )
                })}
              </Checkbox.Group>
            </Form.Item>
          </Row> */}
          {checkData && checkData.find((v: any) => v.code === '4') ? (
            <>
              {/* <Row>
                <Form.Item
                  colon={false}
                  label='辅助诊断设置'
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                ></Form.Item>
              </Row> */}
              {/* <Row>
                <Form.Item
                  label='病历诊断风险提示'
                  name={Checks.BLFX}
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Radio.Group>
                    <Radio value='true'>风险提示</Radio>
                    <Radio value='false'>不提示</Radio>
                  </Radio.Group>
                </Form.Item>
              </Row> */}
              {/* <Row>
                <Form.Item
                  label='医嘱处方风险提示'
                  name={Checks.BLFX}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                  valuePropName='checked'
                >
                 <Checkbox>启用</Checkbox> 
                  <Radio.Group>
                    <Radio value='true'>风险提示</Radio>
                    <Radio value='false'>不提示</Radio>
                  </Radio.Group>
                </Form.Item>
              </Row> */}
            </>
          ) : (
            <></>
          )}
          <Row>
            <Form.Item
              label='输入法设置'
              name={Checks.SRFSZ}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
              }}
              initialValue={'0'}
            >
              <Radio.Group>
                <Radio value='0'>拼音</Radio>
                <Radio value='1'>
                  <div style={{ display: 'flex' }}>
                    <div>五笔</div>
                    <div style={{ marginLeft: '100px' }}>
                      （作用于处方和疾病搜索）
                    </div>
                  </div>
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              label='开方同步同组药品的频次/用法/天数'
              name={Checks.Hbfz}
              valuePropName='checked'
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Checkbox ><span>开启</span><span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>(开启后,同组药品的频次/用法/天数会保持一致,如不一致会自动调整,会以同组药品的第一个药为准)</span></Checkbox>
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              label='小程序权限'
              name={Checks.XCXQX}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
              }}
              valuePropName='checked'
            >
              <Checkbox />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
                label='结算后自动跳打印预览'
                name={Checks.JSHZDTDYYL}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
                valuePropName='checked'
              >
                <Checkbox><span>开启</span><span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>(开启后，收费结束后系统会自动弹出“选择打印模版”弹窗；如不需要则不要开启)</span></Checkbox>
            </Form.Item>
          </Row>
          <Row className={styles.noMarginBottom}>
            <Col span={6} style={{ textAlign: 'right' }}>
              <span>自动打印设置&nbsp;:&nbsp;&nbsp;</span>
            </Col>
            <Col span={16} style={{ display: 'flex' }}>
              <Checkbox
                checked={printFlag}
                onChange={(v) => {
                  setPrintFlag(v?.target.checked)
                }}
              >
                结算后自动 打印 / 开票
              </Checkbox>
              <Form.Item
                name={Checks.FPXZ}
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Select
                  style={{ width: '100%' }}
                  className={styles.addtion}
                  mode='multiple'
                  showArrow
                  showSearch={false}
                // onChange={(v:any) => {
                //   if (v?.length > 6) {
                //     notification.info({
                //       message: '最多只能添加6个模板',
                //     })
                //   }
                // }}
                // suffixIcon={<CaretDownFilled />}
                >
                  {templateList?.map((v: any) => (
                    <Option key={v?.templateId} value={v?.templateId}>
                      {v?.templateDesc}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={6}></Col>
            <Col span={16}>
              <Form.Item
                label=''
                name={Checks.TLXCFHBBHB}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
                initialValue={true}
              >
                <Radio.Group>
                  <Radio value={true}>同类型处方合并</Radio>
                  <Radio value={false}>
                    同类型处方不合并
                  </Radio>
                </Radio.Group>
              </Form.Item>
                          {/* isTlXCFHBBHB 为 false 时 */}</Col>
          </Row>
          {/* {stationCategory == StationCategory.DoctorOrPharmacist ? (
            <Row className={styles.phszStyle}>
              <Form.Item
                label=' '
                name=''
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Button
                  type='primary'
                  onClick={() => setiPreferencesSetShow(true)}
                >
                  偏好设置
                </Button>
              </Form.Item>
            </Row>
          ) : (
            ''
          )} */}
          </div>
          <Row gutter={20}>
            <Col
              offset={10}
              span={10}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              <Button
                className={styles.buttom_submit}
                type='primary'
                size='middle'
                loading={submitLoading}
                onClick={form.submit}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
        <Modal
          width={350}
          title={null}
          visible={isModalVisible}
          footer={null}
          centered
          closable={false}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CloseCircleOutlined
              style={{ fill: 'red', fontSize: '18px', marginRight: '20px' }}
            />
            <p className={styles.message}>请至少勾选保存一份诊断病历</p>
          </div>
        </Modal>

        <PreferencesSetModal
          tabNum={'1'}
          userIdRow={userId}
          userName={userName}
          isModalVisible={preferencesSetShow}
          handleCancel={() => setiPreferencesSetShow(false)}
          onsubmit={() => {
            // PreferencesSetChange && PreferencesSetChange()
            setiPreferencesSetShow(false)
          }}
        />
      </div>
    </>
  )
}
